<template>
  <v-content>
    <v-portal-tool-bar/>
    <v-img
      :src="mainImage"
      gradient="to top right, rgba(0,0,0,.33), rgba(0,0,0,.7)"
      :height="mainImageHeight"
      :contain="isMobile"
    >
      <v-container
        fill-height
        class="main--text"
      >
        <v-row
          justify=end
          align=center
        >
          <v-col
            md=7
          >
            <v-row
            >
              <div :class="headingTextContainerStyle">
                <h1
                  class="white--text title--text"
                  :class="headingTextStyle"
                >
                  自宅で始める<br>プログラミング学習
                </h1>
              </div>
            </v-row>
          </v-col>
        </v-row>
      </v-container>
    </v-img>
    <v-container>
      <v-row
        justify=center
        align=center
      >
        <v-col cols=12>
          <h3 class="text-center font-weight-black">サービス一覧</h3>
        </v-col>
      </v-row>
    </v-container>
    <v-container
      class="main--text"
      fluid>
      <v-row
        justify=center
      >
        <v-col
          md=4
          cols=12
        >
          <VMineCraftServiceCard/>
        </v-col>
        <v-col
          md=4
          cols=12
        >
          <VTextBooksServiceCard/>
        </v-col>
        <v-col
          md=4
          cols=12
        >
          <VVideoLessonsServiceCard/>
        </v-col>
      </v-row>
    </v-container>
    <v-sheet>
      <v-container
        class="main--text">
        <v-to-contact-icon/>
      </v-container>
    </v-sheet>
    <v-container
      class="main--text"
      fluid>
      <v-row
        justify=space-around
      >
        <v-col
          md=4
          cols=12
        >
          <v-card
            tile
          >
            <v-container>
              <v-row
                justify=center>
                <v-col
                  cols=auto>
                  <h2 class="justify-center font-weight-bold">
                    優秀な講師陣
                  </h2>
                </v-col>
              </v-row>
              <v-row
                justify=center
              >
                <v-icon
                  size="100px"
                  color="blue"
                >
                  fa-chalkboard-teacher
                </v-icon>
              </v-row>
            </v-container>
            <v-card-text>
              現役ITエンジニアを初めとして、日夜プログラミングと向き合っている、優秀なメンバーを揃えています。情報技術だけでなく、生徒の方と向き合い、適切に指導するためのコーチングスキルにも自信があります。
            </v-card-text>
          </v-card>
        </v-col>
        <v-col
          md=4
          cols=12
        >
          <v-card
            tile
          >
            <v-container>
              <v-row
                justify=center
              >
                <v-col
                  cols=auto>
                  <h2 class="justify-center font-weight-bold">
                    完全オンライン授業
                  </h2>
                </v-col>
              </v-row>
              <v-row
                justify=center>
                <v-icon
                  size="100px"
                  color="blue"
                >
                  fas fa-desktop
                </v-icon>
              </v-row>
            </v-container>
            <v-card-text>
              ご自宅からブラウザを通して受講いただけます。ビデオ通話を内蔵しておりますので、全国どこでも対面授業が可能です。通塾・転居などの心配をすることなく、腰を据えて学ぶことができます。
            </v-card-text>
          </v-card>
        </v-col>
        <v-col
          md=4
          cols=12
        >
          <v-card
            tile
          >
            <v-container>
              <v-row
                justify=center
              >
                <v-col
                  cols=auto>
                  <h2 class="justify-center font-weight-bold">
                    柔軟なカリキュラム
                  </h2>
                </v-col>
              </v-row>
              <v-row
                justify=center>
                <v-icon
                  size="100px"
                  color="blue"
                >
                  fa-cogs
                </v-icon>
              </v-row>
            </v-container>
            <v-card-text>
              ゲームやWebサービスを作るための、本格的なプログラミングを学びます。カリキュラムは一人ひとりの意欲・理解度に応じ、個別に調整します。マンツーマン指導ならではの、柔軟かつ、きめ細かな対応が可能です。
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
    <v-portal-footer/>
  </v-content>
</template>

<script>
import MainImage from '@/assets/img/main_image.jpg'
import VSectionBar from '@/components/molecules/VSectionBar.vue'
import VPortalToolBar from '@/components/organisms/portal/VPortalToolBar.vue'
import VPortalFooter from '@/components/organisms/portal/VPortalFooter.vue'
import VToContactIcon from '@/components/organisms/portal/VToContactIcon.vue'
import VMineCraftServiceCard from '@/components/organisms/portal/services/VMineCraftServiceCard.vue'
import VTextBooksServiceCard from '@/components/organisms/portal/services/VTextBooksServiceCard.vue'
import VVideoLessonsServiceCard from '@/components/organisms/portal/services/VVideoLessonsServiceCard.vue'

export default {
  components: {
    VPortalToolBar,
    VPortalFooter,
    VToContactIcon,
    VSectionBar,
    VMineCraftServiceCard,
    VTextBooksServiceCard,
    VVideoLessonsServiceCard
  },
  data: () => {
    return {
      mainImage: MainImage
    }
  },
  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.xs
    },
    headingTextStyle() {
      return {
        'heading-text': !this.isMobile,
        'heading-text-mobile': this.isMobile
      }
    },
    headingTextContainerStyle() {
      return {
        'heading-text-container-mobile': this.isMobile
      }
    },
    mainImageHeight() {
      return this.isMobile ? null : 700
    }
  }
}
</script>

<style scoped>

.heading-text {
  font-size: 5.5rem;
  letter-spacing: 5px;
}

.heading-text-mobile {
  font-size: 2.0rem;
  letter-spacing: 3px;
}

.heading-text-container-mobile {
  padding: 10px;
}
</style>

